const ru = {
  uxcore: 'UX Core',
  ai: 'Искусственный Интеллект и Вайбкодинг',
  thoughts: 'Разное',
  pm: 'Управление проектами',
  uxcoreId: 'UX Core',
  aiId: 'AI',
  thoughtsId: 'Thoughts',
  pmId: 'Project Management',
};

export default ru;
